module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Objetivos*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Enumere os objetivos propostos para o projeto. Devem ser formulados com o tempo verbal no infinitivo, indicando uma ação."
    },
    model: {
      value: (_vm.projetoPesquisa.objetivos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "objetivos", $$v)
      },
      expression: "projetoPesquisa.objetivos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Metodologia*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Deve explicitar como serão analisados os dados levantados, incluindo método da pesquisa, materiais e público-alvo, se for o caso."
    },
    model: {
      value: (_vm.projetoPesquisa.metodologia),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "metodologia", $$v)
      },
      expression: "projetoPesquisa.metodologia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Principal Objetivo de Desenvolvimento Sustentável*",
      "items": _vm.listaPrincipalODS,
      "item-text": "descricao",
      "item-value": "id",
      "return-object": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.principalODS),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "principalODS", $$v)
      },
      expression: "projetoPesquisa.principalODS"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Objetivo de Desenvolvimento Sustentável Afim*",
      "items": _vm.listaODSAfim,
      "item-text": "descricao",
      "item-value": "id",
      "return-object": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.afimODS),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "afimODS", $$v)
      },
      expression: "projetoPesquisa.afimODS"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Resultados esperados*",
      "counter": "2000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max2000caracteres),
      "hint": "Devem estar claras as metas que se deseja alcançar com o desenvolvimento desta pesquisa e as contribuições esperadas para a área do conhecimento."
    },
    model: {
      value: (_vm.projetoPesquisa.resultadosEsperados),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resultadosEsperados", $$v)
      },
      expression: "projetoPesquisa.resultadosEsperados"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8a0bc2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-detalhamento.vue
// module id = 895
// module chunks = 0